import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { CATEGORY_META } from "../constants/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CATS = Object.keys(CATEGORY_META).filter((k) => k !== "all");
const EMPTY = { title: "", date: "", category: "streaming", description: "", cringe: 7, evidence_url: "", submitted_by: "" };

const field = "w-full bg-black text-white font-mono text-sm px-3 py-2 brutal-border focus:outline-none focus:bg-[#111] placeholder:text-white/30";
const label = "font-mono text-[10px] uppercase tracking-widest text-[#FFEA00]";

export const SubmitForm = ({ onSubmitted }) => {
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const payload = { ...form, cringe: Number(form.cringe) };
      if (!payload.evidence_url) delete payload.evidence_url;
      if (!payload.submitted_by) delete payload.submitted_by;
      const r = await axios.post(`${API}/submissions`, payload);
      toast.success("FILED. NOW GET 5 WITNESSES TO SECOND IT.");
      setForm(EMPTY);
      onSubmitted && onSubmitted(r.data);
    } catch (err) {
      const d = err?.response?.data?.detail;
      const msg = Array.isArray(d) ? d.map((x) => `${x.loc?.slice(-1)[0]}: ${x.msg}`).join(" · ") : d || "Submission failed. Try again.";
      setError(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4 bg-[#18181b] brutal-border brutal-shadow-y p-5" data-testid="submit-form">
      <div className="space-y-1">
        <label className={label} htmlFor="sub-title">Headline *</label>
        <input id="sub-title" required minLength={8} maxLength={120} className={field} value={form.title} onChange={set("title")} placeholder="e.g. Tries to tip a valet in memecoin" data-testid="submit-title" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <div className="space-y-1">
          <label className={label} htmlFor="sub-date">Date *</label>
          <input id="sub-date" type="date" required className={field} value={form.date} onChange={set("date")} data-testid="submit-date" />
        </div>
        <div className="space-y-1">
          <label className={label} htmlFor="sub-cat">Category *</label>
          <select id="sub-cat" className={field} value={form.category} onChange={set("category")} data-testid="submit-category">
            {CATS.map((c) => <option key={c} value={c}>{CATEGORY_META[c].label}</option>)}
          </select>
        </div>
        <div className="space-y-1">
          <label className={label} htmlFor="sub-cringe">Cringe: <span className="text-white">{form.cringe}/10</span></label>
          <input id="sub-cringe" type="range" min={1} max={10} className="w-full accent-[#FF003C] h-9" value={form.cringe} onChange={set("cringe")} data-testid="submit-cringe" />
        </div>
      </div>
      <div className="space-y-1">
        <label className={label} htmlFor="sub-desc">What did he do? * <span className="text-white/40">({form.description.length}/600)</span></label>
        <textarea id="sub-desc" required minLength={20} maxLength={600} rows={4} className={field} value={form.description} onChange={set("description")} placeholder="Keep it factual-ish. Roast allowed. Defamation not." data-testid="submit-description" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div className="space-y-1">
          <label className={label} htmlFor="sub-url">Evidence link (YouTube / X)</label>
          <input id="sub-url" type="url" className={field} value={form.evidence_url} onChange={set("evidence_url")} placeholder="https://" data-testid="submit-evidence" />
        </div>
        <div className="space-y-1">
          <label className={label} htmlFor="sub-by">Your alias</label>
          <input id="sub-by" maxLength={40} className={field} value={form.submitted_by} onChange={set("submitted_by")} placeholder="anonymous_witness" data-testid="submit-alias" />
        </div>
      </div>
      {error && (
        <div className="font-mono text-xs bg-[#FF003C] text-white px-3 py-2 brutal-border" style={{ borderWidth: 3 }} data-testid="submit-error">
          {error}
        </div>
      )}
      <button type="submit" disabled={busy} data-testid="submit-button" className="brutal-press inline-flex items-center gap-2 bg-[#FFEA00] text-black font-bold uppercase px-5 py-3 brutal-border disabled:opacity-60" style={{ boxShadow: "6px 6px 0 0 #FF003C" }}>
        <Send size={16} strokeWidth={3} />
        {busy ? "Filing..." : "File the Report"}
      </button>
      <p className="font-mono text-[10px] text-white/40">
        Light moderation: reports sit in the Docket until 5 visitors second them, then they graduate to the Timeline as a PATTERN entry.
      </p>
    </form>
  );
};
